
import { motion } from "framer-motion";

export default function LoadingScreen() {
  return (
    <motion.div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-center relative"
      >
        {/* Profile picture with breathing effect */}
        <motion.div
          className="w-40 h-40 rounded-full overflow-hidden relative animate-pulse-glow"
          animate={{
            scale: [1, 0.92, 1.1, 1],
            filter: [
              'blur(0px)',
              'blur(3px)', 
              'blur(1px)',
              'blur(0px)'
            ]
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          style={{
            transformOrigin: 'center center'
          }}
        >
          <motion.img 
            src="/assets/jonas_siebler_profile_pic.jpg" 
            alt="Loading" 
            className="w-full h-full object-cover"
            animate={{
              filter: [
                'saturate(1)',
                'saturate(0.8)',
                'saturate(1.1)',
                'saturate(1)'
              ]
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          
          {/* Overlay for additional breathing effect */}
          <motion.div
            className="absolute inset-0 rounded-full"
            style={{
              background: 'radial-gradient(circle at center, transparent 40%, rgba(147, 51, 234, 0.1) 50%, transparent 60%)',
              mixBlendMode: 'overlay'
            }}
            animate={{
              scale: [0.8, 1.2, 0.9, 0.8],
              opacity: [0.2, 0.6, 0.4, 0.2]
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </motion.div>

        {/* Outer breathing rings */}
        <motion.div
          className="absolute inset-0 w-40 h-40 rounded-full border border-primary/20"
          animate={{
            scale: [1, 1.3, 1.1, 1],
            opacity: [0.3, 0.1, 0.4, 0.3]
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        
        <motion.div
          className="absolute inset-0 w-40 h-40 rounded-full border border-primary/15"
          animate={{
            scale: [1, 1.5, 1.2, 1],
            opacity: [0.2, 0.05, 0.3, 0.2]
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 0.5
          }}
        />
      </motion.div>
    </motion.div>
  );
}
